import { ADA_KEYBOARD_CLASS_NAME } from '../constants';

export default class TabList {
  constructor(e, callback = null) {
    this.$this = $(e);
    this.callback = callback;
    this.tablist = this.$this.find('.tablist');
    this.tabs = this.$this.find('[role=tab]');
    this.panels = this.$this.find('[role=tabpanel]');
    this.clsTabHidden = 'is-hidden hidden';
    this.opacityHidden = 'opacity-0';
    this.opacityShow = 'opacity-100 transform-active';
    this.isSelectTabs = this.$this.find('.js-select-tabs').length;
    this.body = $('body');
    this.$html = $('html');
    this.text = {
      ariaControlsText: 'aria-controls',
    };
    this.classes = {
      option: '.optiton-select',
    };
    this.keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      delete: 46,
    };
    this.direction = {
      37: -1,
      38: -1,
      39: 1,
      40: 1,
    };
  }

  init() {
    this.addListeners();
  }

  // Bind listeners
  addListeners() {
    if (this.isSelectTabs) {
      this.$this.on('click', this.classes.option, (e) => {
        this.clickEventListener(e);
      });
      this.$this.on('keydown', this.classes.option, (e) => {
        this.keydownEventListener(e);
      });
      this.$this.on('keyup', this.classes.option, (e) => {
        this.keyupEventListener(e);
      });
      this.$this.on('focus', this.classes.option, (e) => {
        if (this.$html.hasClass(ADA_KEYBOARD_CLASS_NAME)) {
          this.focusEventHandler(e);
        }
      });
    } else {
      this.tabs.on('click', (e) => {
        this.clickEventListener(e);
      });
      this.tabs.on('keydown', (e) => {
        this.keydownEventListener(e);
      });
      this.tabs.on('keyup', (e) => {
        this.keyupEventListener(e);
      });
      this.tabs.on('focus', (e) => {
        if (this.$html.hasClass(ADA_KEYBOARD_CLASS_NAME)) {
          this.focusEventHandler(e);
        }
      });
    }
  }

  clickEventListener(event) {
    const tab = event.currentTarget;
    this.activateTab(tab, false);
  }

  keydownEventListener(event) {
    const key = event.keyCode;

    switch (key) {
      case this.keys.end:
        event.preventDefault();
        // Activate last tab
        this.activateTab(this.tabs[this.tabs.length - 1], true);
        break;
      case this.keys.home:
        event.preventDefault();
        // Activate first tab
        this.activateTab(this.tabs[0], true);
        break;
      // Up and down are in keydown
      // because we need to prevent page scroll >:)
      case this.keys.up:
      case this.keys.down:
        this.determineOrientation(event);
        break;
      default:
        break;
    }
  }

  // Handle keyup on tabs
  keyupEventListener(event) {
    const key = event.keyCode;
    switch (key) {
      case this.keys.left:
      case this.keys.right:
        this.determineOrientation(event);
        break;
      case this.keys.delete:
        this.determineDeletable(event);
        break;
      default:
        break;
    }
  }

  determineOrientation(event) {
    const key = event.keyCode;
    const vertical = this.tablist.attr('aria-orientation') === 'vertical';
    let proceed = false;
    if (vertical && key === this.keys.up || key === this.keys.down) {
      event.preventDefault();
      proceed = true;
    }
    if (!vertical && key === this.keys.left || key === this.keys.right) {
      proceed = true;
    }
    if (proceed) {
      this.switchTabOnArrowPress(event);
    }
  }

  // Either focus the next, previous, first, or last tab
  // depending on key pressed
  switchTabOnArrowPress(event) {
    const pressed = event.keyCode;

    if (this.direction[pressed]) {
      const { target } = event;
      if (this.tabs[$(target).index() + this.direction[pressed]]) {
        this.tabs[$(target).index() + this.direction[pressed]].focus();
      } else if (pressed === this.keys.left || pressed === this.keys.up) {
        this.focusLastTab();
      } else if (pressed === this.keys.right || pressed === this.keys.down) {
        this.focusFirstTab();
      } else {
        // do nothing
      }
    }
  }

  // Activates any given tab panel
  activateTab(tab, keydown = false) {
    if ((!$(tab).hasClass('active') && !this.isSelectTabs) || (!$(tab).hasClass('selected') && this.isSelectTabs)) {
      this.deactivateTabs();
      if (!this.isSelectTabs) {
        $(tab)
          .attr({
            tabindex: '0',
            'aria-selected': 'true',
          })
          .addClass('active');
      }
      this.checkFirstTab(tab);
      $(`#${$(tab).attr(this.text.ariaControlsText)}`).removeClass(this.clsTabHidden);
      setTimeout(() => {
        $(`#${$(tab).attr(this.text.ariaControlsText)}`).addClass(this.opacityShow);
        $(`#${$(tab).attr(this.text.ariaControlsText)}`).removeClass(this.opacityHidden);
        const $urlImage = $(`#${$(tab).attr(this.text.ariaControlsText)}`).find('.zoom-on-item img').attr('src');
        if ($urlImage) {
          const img = new Image();
          img.src = $urlImage;
          img.onload = () => {
            $(`#${$(tab).attr(this.text.ariaControlsText)}`).find('.loader-center').addClass('hidden');
          };
        }
        this.TrimBannerHeroColor($(`#${$(tab).attr(this.text.ariaControlsText)}`));
        if (window.lazyLoadImage) {
          window.lazyLoadImage.onScroll();
        }
        if (typeof this.callback === 'function') {
          this.callback();
        }
      }, 50);
      if (keydown) {
        $(tab).focus();
      }
    }
  }

  checkFirstTab(tab) {
    const firstTabActive = 'first-tab-active';
    if ($(tab).parents('.trim-banner-tab').length > 0) {
      if ($(tab).index() === 0 && !this.body.hasClass('change-slide')) {
        if ($(`#${$(tab).attr(this.text.ariaControlsText)}`).find('.color-main-item.active').find('>*').length < 2) {
          this.body.removeClass(firstTabActive);
        }
      } else {
        this.body.removeClass(firstTabActive);
      }

      if ($(tab).index() !== 0 && window.innerWidth < 1200 && $(tab).parents('.mod-trim-banner-hero').length > 0 && $(window).scrollTop() < 16) {
        this.$html.addClass('show-scroll');
        this.body.addClass('wheel-down');
        $('header').addClass('hide-header');
        window.scrollTo(0, 50);
      }
    }
  }

  TrimBannerHeroColor(tab) {
    const fakeColor = '.mod-trim-banner-hero .fake-color-trim';
    const dataColorAtt = 'data-color';
    const checkActive = 'checked';
    const activeColor = '.color-main-item.active';
    const activeTab = 'active';
    const colorMain = '.color-main-item';
    const jsColorName = '.mod-trim-banner-hero .js-color-name';

    if (!tab.find(activeColor).length) {
      $(tab.find(colorMain)[0]).addClass(activeTab);
      const dataColor = $(tab.find(colorMain)[0]).attr(dataColorAtt);
      tab.find(`[${dataColorAtt}="${dataColor}"]`).addClass(activeTab);
      $(tab.find(`[${dataColorAtt}="${dataColor}"]`)[1]).prop(checkActive, true);
    } else {
      const dataColor = $(tab.find(activeColor)).attr(dataColorAtt);
      tab.find(`[${dataColorAtt}="${dataColor}"]`).addClass(activeTab);
      $(tab.find(`[${dataColorAtt}="${dataColor}"]`)[1]).prop(checkActive, true);
    }

    const dataColor = $(tab.find(activeColor)).attr(dataColorAtt);
    $(fakeColor).find(`[${dataColorAtt}="${dataColor}"]`).addClass(activeTab);
    $(fakeColor).find(`[${dataColorAtt}="${dataColor}"]`).prop(checkActive, true);
    $(jsColorName).text($(fakeColor).find(`[${dataColorAtt}="${dataColor}"]`).attr(dataColorAtt));
  }

  // Deactivate all tabs and tab panels
  deactivateTabs() {
    if (!this.isSelectTabs) {
      this.tabs
        .attr({
          tabindex: '-1',
          'aria-selected': 'false',
        })
        .removeClass('active');
    }
    this.panels.removeClass(this.opacityShow);
    this.panels.addClass(this.opacityHidden);
    this.panels.addClass(this.clsTabHidden);
  }

  // Make a guess
  focusFirstTab() {
    this.tabs[0].focus();
  }

  // Make a guess
  focusLastTab() {
    this.tabs[this.tabs.length - 1].focus();
  }

  // Detect if a tab is deletable
  determineDeletable(event) {
    const { target } = event;
    if ($(target).attr('data-deletable') !== null) {
      // Delete target tab
      this.deleteTab(event, target);
      // Update arrays related to tabs widget
      this.tabs = this.$this.find('[role=tab]');
      this.panels = this.$this.find('[role=tabpanel]');

      // Activate the closest tab to the one that was just deleted
      if ($(target).index() - 1 < 0) {
        this.activateTab(this.tabs[0]);
      } else {
        this.activateTab(this.tabs[$(target).index() - 1]);
      }
    }
  }

  // Deletes a tab and its panel
  deleteTab(event) {
    const { target } = event;
    const $panel = $(`#${$(target).attr(this.text.ariaControlsText)}`);
    $panel.remove();
    $(target).remove();
  }

  focusEventHandler(event) {
    if (this.isSelectTabs) { return; }
    const { target } = event;
    const focused = document.activeElement;
    if (target === focused) {
      this.activateTab(target, false);
    }
  }
}

const $tabs = $('.mod-tabs');
if ($tabs.length) {
  $tabs.each((_i, e) => {
    new TabList(e).init();
  });
}
